import { baseApiSlice } from "@src/services/slices/baseApiSlice";
import { Note, NoteHistory } from "@src/types";
import { message } from "antd";
import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";

export const notesApiSlice = baseApiSlice.injectEndpoints({
  endpoints: (builder: EndpointBuilder<any, any, any>) => ({
    /* GET endpoints */
    ...getEndpoints(builder),

    /* POST endpoints */
    ...postEndpoints(builder),
  }),
});

function getEndpoints(builder: EndpointBuilder<any, any, any>) {
  return {
    /**
     * Get a note
     */
    getNote: builder.query<Note[], number>({
      query: (requestId) => `notes/request/${requestId}`,
      transformErrorResponse: async () => {
        message.error("Failed to get note", 5);
      },
      providesTags: ["Notes"],
    }),

    /**
     * Get note history
     */
    getNoteHistory: builder.query<NoteHistory[], number>({
      query: (requestId) => `notes/history/request/${requestId}`,
      transformErrorResponse: async () => {
        message.error("Failed to get note history", 5);
      },
      providesTags: ["NoteHistory"],
    }),
  };
}

function postEndpoints(builder: EndpointBuilder<any, any, any>) {
  const baseMethod = "POST";

  return {
    /**
     * Create a new note
     */
    addNote: builder.mutation<void, Note>({
      query: (note) => ({
        url: "notes",
        method: baseMethod,
        body: note,
      }),
      transformErrorResponse: async () => {
        message.error("Error creating new note", 5);
      },
      invalidatesTags: ["Notes", "TeamLeadRequestDetails"],
    }),

    /**
     * Save note read status
     */
    saveNoteStatus: builder.mutation<void, NoteHistory>({
      query: (note) => ({
        url: "notes/read-status",
        method: baseMethod,
        body: note,
      }),
      transformErrorResponse: async () => {
        message.error("Failed to save note read status", 5);
      },
      invalidatesTags: ["Notes", "NoteHistory", "RoleRequests", "Requests"],
    }),
  };
}

export const {
  /* GET endpoints */
  useGetNoteQuery,
  useGetNoteHistoryQuery,
  useLazyGetNoteQuery,

  /* POST endpoints */
  useAddNoteMutation,
  useSaveNoteStatusMutation,
} = notesApiSlice;
